import React, { useState } from 'react';
import Footer from '../Pages/Footer';
import Navbar from '../Navbar';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { useSiteConfig } from '../contexts/SiteConfigContext';

export default function Contact() {
  const { config } = useSiteConfig();
  const contact = config.contact;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [number, setNumber] = useState("");
  const [content, setContent] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();

  const SubmitForm = async (event) => {
    event.preventDefault();
    setSending(true);
    try {
      await fetch('https://backend-ged-immo.onrender.com/api/contact', {
        method: "POST",
        headers: { 'Content-Type': "application/json" },
        body: JSON.stringify({ name, email, number, content }),
      });
      setSent(true);
      setName(""); setEmail(""); setContent(""); setNumber("");
      setTimeout(() => navigate('/'), 2500);
    } catch {
      alert("Erreur d'envoi, réessayez plus tard.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
      <SEO
        title="Contact — Contactez SCI MAYEDO"
        description="Contactez SCI MAYEDO pour toute demande d'information sur nos biens immobiliers à vendre ou à louer en Côte d'Ivoire. Notre équipe vous répond rapidement."
        canonical="/contact"
      />
      <Navbar />
      <div className="main--contact">
        <h1 className='header__contact'>Contactez l'Agence</h1>
        <h5 className='header__contact'>Remplissez notre formulaire de contact</h5>
        <div className="main--contact--content">

          <div className="main--contact--content--left">
            <div className='form__container'>
              {sent ? (
                <div style={{ textAlign: "center", padding: "2rem", color: "#16a34a" }}>
                  <i className="fa-solid fa-circle-check" style={{ fontSize: "2.5rem", marginBottom: "1rem", display: "block" }}></i>
                  <p style={{ fontWeight: 600, fontSize: "1.1rem" }}>Message envoyé avec succès !</p>
                  <p style={{ color: "#5a6e8c" }}>Nous vous répondrons dans les plus brefs délais.</p>
                </div>
              ) : (
                <form onSubmit={SubmitForm}>
                  <div className="mb-3">
                    <label className="form-label">Noms & Prénoms</label>
                    <input type="text" className="form-control" required value={name} onChange={(e) => setName(e.target.value)} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Adresse e-mail</label>
                    <input type="email" className="form-control" placeholder="nom@exemple.com" required value={email} onChange={(e) => setEmail(e.target.value)} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Numéro de téléphone</label>
                    <input type="text" className="form-control" placeholder="+225 07 …" value={number} onChange={(e) => setNumber(e.target.value)} />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Votre message</label>
                    <textarea className="form-control" rows="4" required value={content} onChange={(e) => setContent(e.target.value)}></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={sending}>
                    {sending ? "Envoi en cours…" : "Envoyer"}
                  </button>
                </form>
              )}
            </div>
          </div>

          <div className="main--contact--content--right">
            <div className='main--contact--content--right--box'>
              <p><strong>Aidez-nous à mieux comprendre vos besoins</strong></p>
              <p><i className="fa-solid fa-location-dot"></i> {contact.address}</p>
              <p><i className="fa-solid fa-phone"></i> {contact.phone}</p>
              <p><i className="fa-solid fa-envelope"></i> {contact.email}</p>
              {contact.hours && <p><i className="fa-solid fa-clock"></i> {contact.hours}</p>}
              {contact.whatsapp && (
                <a
                  href={`https://wa.me/${contact.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ display: "inline-flex", alignItems: "center", gap: 8, marginTop: 12, background: "#25D366", color: "#fff", padding: "8px 16px", borderRadius: 8, fontWeight: 600, textDecoration: "none" }}
                >
                  <i className="fa-brands fa-whatsapp"></i> Écrire sur WhatsApp
                </a>
              )}
            </div>
          </div>

        </div>
      </div>
      <Footer />
    </div>
  );
}
